import type { ResourceCreatorPageModelState } from './types';

export const initialState: ResourceCreatorPageModelState = {
  userInfo: null,

  step: 1,

  step1_resourceType: null,
  step1_resourceType_errorText: '',
  step1_resourceTitle: '',
  step1_resourceTitle_errorText: '',
  step1_resourceName: '',
  step1_resourceName_optimized: '',
  step1_resourceName_isVerify: false,
  step1_resourceName_errorText: '',
  step1_createdResourceInfo: null,
  step1_dataIsDirty_count: 0,

  step2_resourceTypeConfig: {
    uploadEntry: [],
    limitFileSize: 0,
    isSupportDownload: false,
    isSupportEdit: false,
    isSupportOptionalConfig: false,
  },
  step2_fileInfo: null,
  step2_videoCover: '',
  step2_systemPropertiesState: 'success',
  step2_systemProperties: [],
  step2_draftAdditionalProperties: [],
  step2_customProperties: [],
  step2_customConfigurations: [],

  step2_directDependencies: [],
  step2_baseUpcastResources: [],
  step2_authExcludedItems: [],
  step2_isCompleteAuthorization: true,
  step2_authReload: 1,

  step2_dataIsDirty_count: 0,
  step2_isOpenMarkdown: false,
  step2_isOpenCartoon: false,

  step3_policies: [],

  step4_resourceCover: '',
  step4_resourceIntroduction: '',
  step4_resourceLabels: [],
  step4_dataIsDirty_count: 0,
};
